import { COPILOT_COLORS, COPILOT_LAYOUT } from 'globalStyles';

const { WPP } = COPILOT_COLORS;
const { SPACING } = COPILOT_LAYOUT;

export const hyperLinkText = {
  textDecorationColor: WPP.blue500,
  bottom: '5px',
};

export const gridStyle = {
  padding: '25px',
};

export const pStyle = {
  padding: '0 0 10px 10px',
};

export const audianceRoportMessageContainer = {
  width: '90%',
  margin: '15px 0px',
  display: 'flex',
  gap: '5px',
  background: WPP.grey300,
  padding: '5px 12px 8px 12px',
  borderRadius: 6,
};

export const downloadReportBtn = {
  display: 'flex',
  position: 'relative',
  alignItems: 'center',
};

export const lableStyle = {
  marginBottom: SPACING[8],
};

export const inlineMessageStyle = {
  marginTop: '-20px',
};
